import { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import { getGranteesAdmin } from "../../core/service/grantees.service";
import { getOutputSubmissionAdmin } from "../../core/service/outputSubmission.service";

// material
import { styled } from "@mui/material/styles";
import { Card, CardHeader } from "@mui/material";

// ----------------------------------------------------------------------

const CHART_HEIGHT = 372;
const LEGEND_HEIGHT = 72;

const ChartWrapperStyle = styled("div")(({ theme }) => ({
  height: 340,
  marginTop: theme.spacing(5) - 10,
  "& .apexcharts-canvas svg": { height: CHART_HEIGHT },
  "& .apexcharts-canvas svg,.apexcharts-canvas foreignObject": {
    overflow: "visible"
  },
  "& .apexcharts-legend": {
    height: LEGEND_HEIGHT,
    alignContent: "center",
    position: "relative !important",
    borderTop: `solid 1px ${theme.palette.divider}`,
    top: `calc(${CHART_HEIGHT - LEGEND_HEIGHT}px) !important`
  }
}));

// ----------------------------------------------------------------------

const formatDataArray = (arr) => {
  const ListGranteesId = arr.grantees.reduce((acc, grantee) => {
    acc.push(grantee.user_id);
    return acc;
  }, []).length;
  const ListOutputsId = [
    ...new Set(
      arr.outputs.reduce((acc, report) => {
        acc.push(report.user_id);
        return acc;
      }, [])
    )
  ].length;

  return {
    total_listGrantees: ListGranteesId || 0,
    total_listReport: ListOutputsId || 0
  };
};

export default function AcceptedPublishedChartAdmin() {
  const [granteesAndOutputs, setGranteesAndOutputs] = useState({});
  const getGranteesAndOutputs = async () => {
    const data = await getGranteesAdmin();
    const dataOutput = await getOutputSubmissionAdmin();
    const { entities: grantees } = data;
    const { entities: outputs } = dataOutput;
    const toFormat = {
      grantees: grantees.filter((e) => e.role_id !== 1),
      outputs: outputs.filter((e) => e.role_id !== 1)
    };
    const res = formatDataArray(toFormat);
    setGranteesAndOutputs(res);
  };
  useEffect(() => {
    getGranteesAndOutputs();
  }, []);

  const dataToChart = (
    (granteesAndOutputs?.total_listReport * 100) /
    granteesAndOutputs?.total_listGrantees
  ).toFixed(2);
  const CHART_DATA = [dataToChart || 0];

  const chartOptions = {
    colors: ["#1CD1A1"],
    labels: ["Progress"],
    legend: { show: false },
    dataLabels: {
      enabled: false,
      formatter: function (val) {
        return val;
      },
      dropShadow: { enabled: true }
    },
    plotOptions: {
      radialBar: { hollow: { size: "50%" } }
    }
  };

  return (
    <Card>
      <CardHeader title="Accepted / Published" />
      <ChartWrapperStyle dir="ltr">
        <ReactApexChart
          type="radialBar"
          series={CHART_DATA}
          options={chartOptions}
          height={360}
        />
      </ChartWrapperStyle>
    </Card>
  );
}
